import styled from 'styled-components';

type ImageProps = {
  width?: number;
  src: string;
  alt: string;
};
export const Image = styled.img.attrs<ImageProps>((props) => ({
  src: props.src,
  alt: props.alt,
}))<ImageProps>`
  ${(props) =>
    props.width &&
    `
            width: ${props.width}px;
            height: ${props.width * 0.6}px;
        `}

  margin-left: auto;
  margin-right: auto;
`;
